import { Button, IconButton, useMediaQuery, useTheme } from "@mui/material";

import { useTranslate } from "src/locales";
import { useLazyGetKnowledgeBaseLinkQuery } from 'src/services/system/system.service';

import Iconify from "src/components/iconify";

export const KnowledgeBaseButton = () => {

  const { t } = useTranslate();

  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [getKnowledgeBaseLink] = useLazyGetKnowledgeBaseLinkQuery();

  const handleClick = async (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    const ssoOptions = await getKnowledgeBaseLink();
    window.open(ssoOptions.data, '_blank');
  };

  if (isMobile) {
    return (
      <IconButton
        color="primary"
        onClick={handleClick}
      >
        <Iconify icon="solar:documents-line-duotone" />
      </IconButton>
    );
  }

  return (
    <Button
      variant="outlined"
      color="primary"
      startIcon={<Iconify icon="solar:documents-line-duotone" />}
      onClick={handleClick}
    >
      {t('common.help')}
    </Button>
  );
}